import React from "react";
import { API, graphqlOperation } from "aws-amplify";
const defaultData = {
  market_volume: {
    prior_day: 0,
    "1m_avg": 0,
    "3m_avg": 0,
    "1y_avg": 0,
  },
  exchange_volume: {
    prior_day: 0,
    "1m_avg": 0,
    "3m_avg": 0,
    "1y_avg": 0,
  },
};
export default function MarketVolume(props) {
  const [marketVolume, setMarketVolume] = React.useState(defaultData);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      setMarketVolume(defaultData);
      refresh();
    }
  }, [props.reload]);

  const refresh = async () => {
    const data = (
      await API.graphql(graphqlOperation(`{get_market_volume_data {data}}`))
    ).data.get_market_volume_data.data;
    setMarketVolume(data);
  };
  return (
    <section className="section market-volume">
      <div className="section-title">
        Total US Market Volume & Exchange Volume
      </div>

      <div className="main-headers">
        <div></div>
        <div className="top-header" style={{ marginBottom: 0 }}>
          Volume (
          {marketVolume.date
            ? new Date(
                new Date(marketVolume.date).setDate(
                  new Date(marketVolume.date).getDate() + 1,
                ),
              ).toLocaleDateString()
            : "N/A"}
          ){" "}
          <div
            data-tip={"The % change in Total US Stock Market Volume."}
            className="info-icon-market-insights"
          >
            i
          </div>
        </div>
      </div>
      <div className="sub-header">
        <div className="sub-header-index">Index</div>
        <div className="sub-header-text">Prior Day</div>
        <div className="sub-header-text">vs</div>
        <div className="sub-header-text">1M Avg.</div>
        <div className="sub-header-text">vs</div>
        <div className="sub-header-text">3M Avg.</div>
        <div className="sub-header-text">vs</div>
        <div className="sub-header-text">1Y Avg.</div>
      </div>
      <div className="table-content">
        <div className="content-column">
          <div style={{ display: "flex" }}>
            <div className="content-text">Total Market Volume</div>
            <div
              data-tip={
                "Total Market Volume is the Total Exchange Volume plus OTC and OTCBB trading volume for all security types."
              }
              className="info-icon"
              style={{
                fontWeight: 100,
                color: "white",
                borderColor: "white",
                marginLeft: 1,
                marginTop: 9,
              }}
            >
              i
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div className="content-text">Total Exchange Volume</div>
            <div
              data-tip={
                "Total Exchange Volume is the Tape A, B, and C volume on all US exchanges."
              }
              className="info-icon"
              style={{
                fontWeight: 100,
                color: "white",
                borderColor: "white",
                marginLeft: 0,
                marginTop: 8,
              }}
            >
              i
            </div>
          </div>
        </div>
        <div className="content-column">
          <div className="content-column">
            <div
              className={`content-number ${
                parseFloat(marketVolume.market_volume["prior_day"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.market_volume["prior_day"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.market_volume["prior_day"]}
            </div>
            <div
              className={`content-number ${
                parseFloat(marketVolume.exchange_volume["prior_day"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.exchange_volume["prior_day"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.exchange_volume["prior_day"]}
            </div>
          </div>
        </div>
        <div className="content-column">
          <div className="content-column">
            <div
              className={`content-number ${
                parseFloat(marketVolume.market_volume["1m_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.market_volume["1m_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.market_volume["1m_avg"]}
            </div>
            <div
              className={`content-number ${
                parseFloat(marketVolume.exchange_volume["1m_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.exchange_volume["1m_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.exchange_volume["1m_avg"]}
            </div>
          </div>
        </div>
        <div className="content-column">
          <div className="content-column">
            <div
              className={`content-number ${
                parseFloat(marketVolume.market_volume["3m_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.market_volume["3m_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.market_volume["3m_avg"]}
            </div>
            <div
              className={`content-number ${
                parseFloat(marketVolume.exchange_volume["3m_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.exchange_volume["3m_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.exchange_volume["3m_avg"]}
            </div>
          </div>
        </div>
        <div className="content-column">
          <div className="content-column">
            <div
              className={`content-number ${
                parseFloat(marketVolume.market_volume["1y_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.market_volume["1y_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.market_volume["1y_avg"]}
            </div>
            <div
              className={`content-number ${
                parseFloat(marketVolume.exchange_volume["1y_avg"]) < 0
                  ? "red"
                  : parseFloat(marketVolume.exchange_volume["1y_avg"]) > 0
                  ? "green"
                  : ""
              }`}
            >
              {marketVolume.exchange_volume["1y_avg"]}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
